import { readContract } from 'viem/actions';
import { permit2ProxyAbi } from '../abi.js';
export const getPermitTransferFromValues = async (client, chain, tokenAddress, amount) => {
    const nonce = await readContract(client, {
        address: chain.permit2Proxy,
        abi: permit2ProxyAbi,
        functionName: 'nextNonce',
        args: [client.account.address],
    });
    return {
        permitted: {
            token: tokenAddress,
            amount: amount,
        },
        spender: chain.permit2Proxy,
        nonce: nonce,
        deadline: BigInt(Math.floor(Date.now() / 1000) + 30 * 60), // 30 minutes
    };
};
//# sourceMappingURL=getPermitTransferFromValues.js.map